export default {
  state: state => state.state,
  activeCamera: state => state.activeCamera,
  linkedTvVideo: state => state.linkedTvVideo,
  linkedVideo: state => state.linkedVideo,
  options: state => state.options,
  defaults: state => state.defaults,
  loading: state => state.loading,
  type: state => state.type,
};
